import { css } from '@emotion/react';
import { Theme } from '@mui/material';

export const styles = {
  container: (theme: Theme) => css`
    margin-top: ${theme.spacing(1)};
    margin-bottom: ${theme.spacing(1)};
  `
};
